import React from 'react'
import { TBody, Row } from 'components/Table'
import { generateSkeletonList } from 'helpers/common'
import { IColumn } from 'types'

interface Props {
  columns: IColumn[]
  rowOdd: Record<string, React.ReactNode>
  rowEven: Record<string, React.ReactNode>
  loopOptional?: number
}

export const SkeletonList = ({
  columns,
  rowOdd,
  rowEven,
  loopOptional,
}: Props): JSX.Element => {
  const base = 'skeleton-list'

  const _Skeleton = generateSkeletonList(
    rowOdd,
    rowEven,
    loopOptional,
  ) as Record<string, React.ReactNode>[]

  return (
    <TBody data-testid={`skeleton-list`}>
      {_Skeleton.map((data, index) => (
        <Row
          className={base}
          key={index}
          columns={columns}
          data={data}
          position='left'
        />
      ))}
    </TBody>
  )
}
